import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Card, Flex, Form, Select, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext, useMemo } from "react";
import { getFieldPath } from "../../functions/Utility";
import { Rule, RULE_TYPES, RuleType } from "../../types/RuleTypes";
import { ListFieldContext } from "./LaterForm";
import { Every_TimeInput } from "./inputs/Every_TimeInput";
import { OnThe_TimeInput } from "./inputs/OnThe_TimeInput";

type Props = {
  onRemove: () => void;
};

export const RuleContext = createContext<Rule | undefined>(undefined);

const ScheduleTypeInputMap: Record<RuleType, React.ReactNode> = {
  on_the: <OnThe_TimeInput />,
  every: <Every_TimeInput />,
};

export const LaterRule = observer((props: Props) => {
  const t = useTranslation();
  const field = useContext(ListFieldContext);
  const ruleValues = useContext(RuleContext);

  const options = useMemo(
    () =>
      RULE_TYPES.map((type) => ({
        label: t("opendash:cron.later.ruleType." + type),
        value: type,
      })),
    []
  );

  return (
    <Card>
      <Flex gap="small">
        <Form.Item name={[getFieldPath(field), "type"]}>
          <Select
            options={options}
            placeholder="Art des Intervalls"
            style={{ minWidth: 200 }}
          />
        </Form.Item>

        {ScheduleTypeInputMap[ruleValues?.type]}

        <Tooltip title={t("opendash:cron.later.rule.remove")}>
          <Button
            danger
            icon={<Icon icon="fa:trash" />}
            onClick={() => props.onRemove()}
          />
        </Tooltip>
      </Flex>
    </Card>
  );
});
